import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { take } from 'rxjs';
import { Objection } from '../../../core/objection/objection';
import { ObjectionService } from '../../../core/objection/objection.service';
import { OpenaiService } from '../../../core/openai/openai.service';
import { SessionMessage } from '../../../core/session-message/session-message';
import { SessionMessageService } from '../../../core/session-message/session-message.service';

@Component({
  selector: 'app-objection-handling-table',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzInputModule,
    NzIconModule,
    NzButtonModule,
    NzTableModule,
    NzPopoverModule,
    NzModalModule,
    NzAlertModule,
    NzPopconfirmModule,
    NzTagModule,
    NzTabsModule,

    MatTooltipModule,
  ],
  templateUrl: './objection-handling-table.component.html',
  styleUrl: './objection-handling-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObjectionHandlingTableComponent {
  @Input() sessionMessageList: SessionMessage[] = [];
  @Input() emotionalObjectionList: Objection[] = [];
  @Input() factObjectionList: Objection[] = [];

  constructor(
    private msg: NzMessageService,
    private openaiService: OpenaiService,
    private objectionService: ObjectionService,
    private sessionMessageService: SessionMessageService
  ) {}

  getMyAnswer(objectionId: string) {
    return this.sessionMessageList?.find((sessionMessage) => sessionMessage.subData.objectionId === objectionId);
  }

  onFactsBasedEvaluateClick(objection: Objection) {
    const myAnswer = this.getMyAnswer(objection.id);

    if (!myAnswer?.subData?.salesMessage) {
      this.msg.error('Cannot get the message to analyze.');
      return;
    }

    this.sessionMessageService
      .evaluateFactBasedObjectionAnswer$(myAnswer, this.sessionMessageList, objection)
      .pipe(take(1))
      .subscribe(() => {});
  }

  onSoftSkillsEvaluateClick(objection: Objection) {
    const myAnswer = this.getMyAnswer(objection.id);

    if (!myAnswer?.subData?.salesMessage) {
      this.msg.error('Cannot get the message to analyze.');
      return;
    }

    const index = this.sessionMessageList?.findIndex(
      (sessionMessage) => sessionMessage.subData.objectionId === objection.id
    );

    const messageList = this.sessionMessageList?.slice(0, index + 1);

    this.sessionMessageService
      .evaluateSoftSkillsObjectionAnswer$(myAnswer, messageList, objection)
      .pipe(take(1))
      .subscribe(() => {});
  }
}
